import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { FormDataService } from 'src/app/services/formulaires/formulaires.services';
import { PageAnchorDirective } from '../directives/page-anchor.directive';

@Component({
  selector: 'app-navbar-right',
  templateUrl: './navbar-right.component.html',
  styleUrls: ['./navbar-right.component.scss'],
})
export class NavbarRightComponent implements OnInit, OnDestroy {
  @Input() navbarRightItems: PageAnchorDirective[];
  @Input() order: number;
  constructor(private formDataService: FormDataService<UntypedFormGroup>, private route: ActivatedRoute) {
    this.scrollSubscription = this.subjectOnScroll
      .asObservable()
      .pipe(debounceTime(20))
      .subscribe(scrollTop => {
        this.updateActiveNavbarRight(scrollTop);
      });
  }


  get visibleItems() {
    return this.navbarRightItems.filter(n => n.visible && n.isParentDisplayed)
  }
  subjectOnScroll: Subject<number> = new Subject<number>();
  private scrollSubscription: Subscription;

  private static isScrollYAtBottom(scrollTop: number) {
    return scrollTop + window.innerHeight >= document.documentElement.offsetHeight;
  }

  private static isScrollYAtTop(scrollTop: number) {
    return scrollTop === 0;
  }

  ngOnDestroy(): void {
    this.scrollSubscription.unsubscribe();
  }

  ngOnInit(): void {
    this.updateActiveNavbarRight(document.documentElement.scrollTop);
  }


  @HostListener('window:scroll', []) onWindowScroll() {
    this.subjectOnScroll.next(document.documentElement.scrollTop);
  }

  updateActiveNavbarRight(scrollTop: number): void {
    if (this.navbarRightItems.length > 0) {
      this.navbarRightItems = this.navbarRightItems.sort((a, b) => a.order - b.order)
      if (NavbarRightComponent.isScrollYAtTop(scrollTop)) {
        this.makeOnlyFirstItemActive();
      } else if (NavbarRightComponent.isScrollYAtBottom(scrollTop)) {
        this.makeOnlyLastItemActive();
      } else {
        let isAlreayOneItemActive = false;
        this.navbarRightItems.forEach(item => {
          if (isAlreayOneItemActive) {
            item.isActive = false;
          } else {
            item.isActive = item.isBottomLowerThanTopClientScreen;
            isAlreayOneItemActive = item.isActive;
          }
        });
      }
    }
  }

  private makeOnlyLastItemActive(): void {
    if (this.navbarRightItems.length > 0) {
      const lastItem = this.navbarRightItems[this.navbarRightItems.length - 1];
      this.navbarRightItems.forEach(item => {
        item.isActive = lastItem === item;
      });
    }
  }

  private makeOnlyFirstItemActive(): void {
    if (this.navbarRightItems.length > 0) {
      const lastItem = this.navbarRightItems[0];
      this.navbarRightItems.forEach(item => {
        item.isActive = lastItem === item;
      });
    }
  }
}
